import React from "react";

import { withStyles } from "@material-ui/core/styles";
import styles from "./WhyUsStyles";

const WhyUs = ({ classes }) => (
  <div className={classes.container}>
    <h4 className="title center">Why Mondaybee?</h4>
    <div className={classes.features}>
      <div className={classes.feature}>
        <img
          src="https://res.cloudinary.com/nrator/image/upload/f_auto,q_auto/v1536047984/mondaybee/assets/user-shield.png"
          alt="images"
          className={classes.featureIcon}
        />
        <h6 className={classes.featureTitle}>High privacy</h6>
        <p className="sm">
          Your photos will not be sent to us until you make an order.
        </p>
      </div>
      <div className={classes.feature}>
        <img
          src="https://res.cloudinary.com/nrator/image/upload/f_auto,q_auto/v1536047716/mondaybee/assets/images.png"
          alt="images"
          className={classes.featureIcon}
        />
        <h6 className={classes.featureTitle}>Free preview</h6>
        <p className="sm">
          Generate as many previews as you like until you’re satisfied.
        </p>
      </div>
      <div className={classes.feature}>
        <img
          src="https://res.cloudinary.com/nrator/image/upload/f_auto,q_auto/v1536047984/mondaybee/assets/smile.png"
          alt="images"
          className={classes.featureIcon}
        />
        <h6 className={classes.featureTitle}>Easy to use</h6>
        <p className="sm">
          Pick your favourite photos and click generate. That’s all you need to
          do.
        </p>
      </div>
    </div>
  </div>
);

export default withStyles(styles)(WhyUs);



// WEBPACK FOOTER //
// ./src/screens/Home/WhyUs.js